import { createStore } from 'vuex'
import modules from './modules';
import { createGlobalTimelineRefreshPlugin } from '@/lib/globalTimelineRefresh'
import { chatTopicsV2Plugins } from '@/lib/chatTopicsV2Plugin'


const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules,
  // Task/event/waiting-on writes anywhere in the app refresh the Global timeline panel.
  plugins: [createGlobalTimelineRefreshPlugin(), ...chatTopicsV2Plugins()],
})

